(() => {
  const globalKey = '__pbHomeV31SocialFeedLoaded';
  if (window[globalKey]) return;
  window[globalKey] = true;

  const validUrl = (value, hostSuffix) => {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && (url.hostname === hostSuffix || url.hostname.endsWith(`.${hostSuffix}`));
    } catch (error) {
      return false;
    }
  };

  const validPermalink = (value) => {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'www.instagram.com' && /^\/(?:p|reel)\/[A-Za-z0-9_-]+\/?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  };

  const documentLabels = () => {
    const language = String(document.documentElement.lang || document.body?.lang || '').toLowerCase();
    return language.startsWith('de')
      ? {
          fallbackTitle: 'Neu von Poco Blush',
          openPost: 'Instagram-Beitrag von Poco Blush öffnen: ',
          contentType: 'INSTAGRAM-BEITRAG',
        }
      : {
          fallbackTitle: 'Latest from Poco Blush',
          openPost: 'Open Poco Blush Instagram post: ',
          contentType: 'INSTAGRAM',
        };
  };

  const titleFromCaption = (caption, labels) => {
    const title = String(caption || '').split(/\n+/).map((line) => line.trim()).find(Boolean);
    return title || labels.fallbackTitle;
  };

  const card = (item) => {
    const labels = documentLabels();
    const title = titleFromCaption(item.caption, labels);
    const link = document.createElement('a');
    link.className = 'pb-home-social__card-link';
    link.href = item.permalink;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', `${labels.openPost}${title}`);

    const media = document.createElement('div');
    media.className = 'pb-home-social__media';
    const image = document.createElement('img');
    image.src = item.image;
    image.alt = title;
    image.loading = 'lazy';
    image.decoding = 'async';
    media.appendChild(image);
    link.appendChild(media);

    const article = document.createElement('article');
    article.className = 'pb-home-social__card';
    article.setAttribute('role', 'listitem');
    article.appendChild(link);
    return article;
  };

  const upgrade = (section, data) => {
    const rail = section && section.querySelector('.pb-home-social__rail');
    if (!rail || !data || data.account !== 'pocoblush' || !Array.isArray(data.items)) return false;
    const items = data.items
      .filter((item) => item && validPermalink(item.permalink) && (validUrl(item.image, 'cdninstagram.com') || validUrl(item.image, 'cdn.shopify.com')))
      .sort((a, b) => new Date(b.timestamp || 0).getTime() - new Date(a.timestamp || 0).getTime())
      .slice(0, 8);
    if (items.length < 8) return false;
    const fragment = document.createDocumentFragment();
    items.forEach((item) => fragment.appendChild(card(item)));
    rail.replaceChildren(fragment);
    rail.dataset.pbFeedSource = 'official-cache';
    rail.dataset.pbFeedCount = String(items.length);
    rail.dataset.pbFeedState = 'ready';
    rail.hidden = false;
    return true;
  };

  const mount = (section) => {
    if (!section || section.dataset.pbSocialFeedMounted === 'true') return;
    section.dataset.pbSocialFeedMounted = 'true';
    const script = document.querySelector('script[data-pb-social-feed-url]');
    const url = script && script.dataset.pbSocialFeedUrl;
    const fallbackUrl = script && script.dataset.pbSocialFeedFallback;
    const fetchFeed = (feedUrl, allowWorker) => {
      let parsed;
      try { parsed = new URL(feedUrl, location.href); } catch (error) { return Promise.resolve(null); }
      const allowed = parsed.origin === location.origin || (allowWorker && parsed.hostname === 'poco-instagram-feed.wilverh.workers.dev');
      if (!allowed) return Promise.resolve(null);
      return fetch(parsed.href, { credentials: 'same-origin' }).then((response) => response.ok ? response.json() : null).catch(() => null);
    };
    fetchFeed(url, true).then((data) => upgrade(section, data)).then((upgraded) => {
      if (!upgraded && fallbackUrl) return fetchFeed(fallbackUrl, false).then((fallback) => upgrade(section, fallback));
      return upgraded;
    }).then((upgraded) => {
      const rail = section.querySelector('.pb-home-social__rail');
      if (!upgraded && rail) {
        rail.replaceChildren();
        rail.hidden = true;
        rail.dataset.pbFeedState = 'unavailable';
      }
    });
  };

  const mountAll = () => document.querySelectorAll('.pb-home-social').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target && event.target.matches && event.target.matches('.pb-home-social') ? event.target : event.target && event.target.querySelector ? event.target.querySelector('.pb-home-social') : null;
    mount(section);
  });
})();
